import { render, staticRenderFns } from "./ListShoppingCart.vue?vue&type=template&id=2ca2545b&"
import script from "./ListShoppingCart.vue?vue&type=script&lang=js&"
export * from "./ListShoppingCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports